import React, { useCallback, useEffect, useState } from 'react'
import { EnumType } from 'json-to-graphql-query'
import classNames from 'classnames'
import Comment from '../../../Comment/index'
import { VuiForm } from '@topkamera/viso-ui'
import { DAYS_TO_INCLUDE_OPTIONS, GRANULARITY_OPTIONS, SERIES_COUNT_OPTIONS } from '../../constants'
import { getDefaultOption } from 'containers/CustomDashboardv2/Dashboard/details/chartConfigurations'

const AskVisoCreateDemo = ({
  color, isFullscreen, isLoading, setPromptValue, setDemoBuildingInput
}) => {
  const defaultDays = getDefaultOption(DAYS_TO_INCLUDE_OPTIONS)
  const defaultGranularity = getDefaultOption(GRANULARITY_OPTIONS)
  const defaultSeriesCount = getDefaultOption(SERIES_COUNT_OPTIONS)

  const [formValues, setFormValues] = useState({
    daysToInclude: [defaultDays],
    granularity: [defaultGranularity],
    seriesCount: [defaultSeriesCount]
  })

  useEffect(() => {
    setDemoBuildingInput({
      days: new EnumType(defaultDays?.value),
      granularity: new EnumType(defaultGranularity?.value),
      seriesCount: new EnumType(defaultSeriesCount?.value)
    })
  }, [])

  const handleChange = useCallback((values) => {
    const getDays = values.daysToInclude?.[0] || {}
    const getGranularity = values.granularity?.[0] || {}
    const getSeriesCount = values.seriesCount?.[0] || {}
    
    const promptValue = `Create demo that includes data from ${getDays?.label} days with ${getGranularity?.label} granularity and ${getSeriesCount?.label} series count`
    const buildInput = {
      days: new EnumType(getDays?.value || formValues.daysToInclude?.[0]?.value),
      granularity: new EnumType(getGranularity?.value || formValues.granularity?.[0]?.value),
      seriesCount: new EnumType(getSeriesCount?.value || formValues.seriesCount?.[0]?.value)
    }
    setPromptValue(promptValue)
    setDemoBuildingInput(buildInput)
    setFormValues(values)
  }, [setPromptValue, setDemoBuildingInput])

  if (isLoading) {
    return null
  }

  return (
    <div className={classNames('ask-viso-create-form', isFullscreen && 'ask-viso-create-form--fullscreen')}>
      <div className='ask-viso-create-form__content'>
        <Comment
          contentClass='ask-viso-chat__comment'
          showAvatar
          hideName
          firstName='A'
          lastName='I'
          color={color}
          text={
            <div className='ask-viso-create-form__form'>
              <div className='ask-viso-create-form__title'>Please provide additional information needed to start.</div>
              <VuiForm
                color={color}
                fields={[
                  {
                    groupProps: {
                      label: 'Days to include'
                    },
                    hasBorderLeft: true,
                    id: 'daysToInclude',
                    type: 'selectinput',
                    fieldProps: {
                      elementId: 'popoverRoot',
                      options: DAYS_TO_INCLUDE_OPTIONS,
                      value: formValues.daysToInclude
                    },
                    fields: [
                      {
                        groupProps: {
                          label: 'Granularity'
                        },
                        fieldProps: {
                          elementId: 'popoverRoot',
                          options: GRANULARITY_OPTIONS,
                          value: formValues.granularity
                        },
                        id: 'granularity',
                        type: 'selectinput'
                      },
                      {
                        groupProps: {
                          label: 'Series count'
                        },
                        fieldProps: {
                          elementId: 'popoverRoot',
                          options: SERIES_COUNT_OPTIONS,
                          value: formValues.seriesCount
                        },
                        id: 'seriesCount',
                        type: 'selectinput'
                      }
                    ],
                  },
                ]}
                onChange={handleChange}
              />
            </div>
          }
        />
      </div>
    </div>
  )
}

export default AskVisoCreateDemo